import PropTypes from "prop-types";
import React from "react";
import { Handle, Position } from "reactflow";
import { IconButton } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown"; // MUI arrow down icon
import { ArrowForward, Block } from "@mui/icons-material";
import userImage from "assets/images/user.png";
import { useTranslation } from "react-i18next";

const CustomNode = ({ data }) => {
  const { t } = useTranslation();
  const displayName = data.label.length > 20 ? data.label.slice(0, 20) + "…" : data.label;
  const displayJob =
    data.jobTitle && data.jobTitle.length > 22 ? data.jobTitle.slice(0, 22) + "…" : data.jobTitle;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        fontWeight: 500,
        padding: 6,
        borderRadius: 8,
        background: "#fff",
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        border: "1px solid #ddd",
        maxWidth: 220,
        position: "relative",
      }}
    >
      <Handle type="target" position={Position.Top} />

      <img
        src={data.photo ? `data:image/png;base64,${data.photo}` : userImage}
        alt=""
        style={{ width: 32, height: 32, borderRadius: "50%" }}
      />

      {/* Name + Job Title stacked */}
      <div style={{ display: "flex", flexDirection: "column", flex: 1, minWidth: 0 }}>
        <span
          title={data.label}
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            fontWeight: 600,
            maxWidth: 120,
          }}
        >
          {displayName}
        </span>
        {data.jobTitle && (
          <span
            title={data.jobTitle}
            style={{
              fontSize: 11,
              color: "#666",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: 120,
            }}
          >
            {displayJob}
          </span>
        )}
      </div>

      <IconButton
        size="small"
        onClick={(event) => data.nodeClick(event, data.id, data.hasChildren)}
        style={{ padding: 4 }}
        title={
          data.noChildren
            ? t("admin.employees.noSubordinates")
            : data.hasChildren
            ? t("admin.employees.subordinatesLoaded")
            : t("admin.employees.loadSubordinates")
        }
        disabled={data.noChildren}
      >
        {data.noChildren ? (
          <Block fontSize="small" />
        ) : data.hasChildren ? (
          <ArrowDropDownIcon fontSize="small" />
        ) : (
          <ArrowForward fontSize="small" />
        )}
      </IconButton>

      <Handle type="source" position={Position.Bottom} />
    </div>
  );
};

CustomNode.propTypes = {
  data: PropTypes.shape({
    label: PropTypes.string.isRequired,
    photo: PropTypes.string,
    nodeClick: PropTypes.func,
    id: PropTypes.string,
    hasChildren: PropTypes.bool.isRequired,
    noChildren: PropTypes.bool.isRequired,
    jobTitle: PropTypes.string.isRequired,
  }).isRequired,
};

export default CustomNode;
